module.exports = __webpack_public_path__ + "doctor_3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/doctors/doctor_3.jpg
// module id = 890
// module chunks = 0